<template>
    <div class="footer">
        <div class="footer-inner">
        <div class="Qrcode">
            
        </div>
        <section style="padding-right: 100px;">
            <div class="item">
                <div class="item-name">上海赛恩工贸有限公司：</div>
                <div class='item-value'>
                    <ul>
                        <li><a href="">发展历程</a></li>
                        <li><a href="">资质荣誉</a></li>
                        <li><a href="">联系我们</a></li>
                    </ul>
                </div>
                <div class="clearfix"></div>
            </div>
            <div class="clearfix"></div>
        </section>
        <section style="padding-right: 100px;">
            <div class="item">
                <div class="item-name">地址：</div>
                <div class='item-value'>
                    上海市宝山区飞马路228号
                </div>
                <div class="clearfix"></div>
            </div>
            <div class="item">
                <div class="item-name">电话：</div>
                <div class='item-value'>
                    021-66872529
                </div>
                <div class="clearfix"></div>
            </div>
            <div class="item">
                <div class="item-name">传真：</div>
                <div class='item-value'>
                    021-66872526
                </div>
                <div class="clearfix"></div>
            </div>
            <div class="item">
                <div class="item-name">邮编：</div>
                <div class='item-value'>
                    200949
                </div>
                <div class="clearfix"></div>
            </div>
            <div class="item">
                <div class="item-name">邮箱：</div>
                <div class='item-value'>
                    shsaien@163.com
                </div>
                <div class="clearfix"></div>
            </div>
            <div class="clearfix"></div>
        </section>
        <section>
            <div class="item-name">友情链接：</div>
            <div class='item-value'>
                <ul>
                    <li><a href="">国家技术质量监督局</a></li>
                </ul>
            </div>
            <div class="clearfix"></div>
        </section>
        <section class='copyright'>
            <div>Copyright Centre Testing International All rights resereved <a target="_blank" href="http://www.beian.miit.gov.cn/">沪ICP备19045397号-3</a></div>
            <div><a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011402008818"><img :src="img2">沪公安网报备 31011402008818 号</a></div>
        </section>
    </div>
    </div>
</template>

<script>
    export default {
        name: "footerBar",
        data() {
            return {
                img1: process.env.BASE_URL + "img/qrcode.png",
                img2: process.env.BASE_URL + "img/Bitmap.png",

            }
        },
        props: {

        },
        methods: {

        }
    }
</script>

<style scoped>
    body,ul,ol,li,p,h1,h2,h3,h4,h5,h6,form,fieldset,table,td,img,div,dl,dt,dd,input{
    margin:0;padding:0;border:0;font-family:"Microsoft YaHei";font-size: 12px;
}
.pull-left{
    float:left;
}
.pull-right{
    float:right;
}
.clearfix{
    clear: both;
}
ul>li{
    list-style: none;
}
a{
    text-decoration: none;
    color: #000000;
	
}
img{
    max-width: 100%;
}
.content{
    padding:30px 80px;
}
    a {
        color: inherit;
    }

    a:link {
        color: inherit;

    }

    a:visited {
        color: inherit;
    }

    a:hover {
        color: inherit;
    }

    a:active {
        color: inherit;
    }

    .footer {
        background: rgb(34, 34, 54);
        padding: 30px 80px 16px;
        position: relative;
        width:100%;
        min-width: 1260px;
    }

    .footer-inner{
        width:1260px;
        margin:0 auto;
        position: relative;
    }

    .item {
        float: left;
        padding-right: 15px;
        line-height: 30px;
    }

    .item-name {
        color: #FFFFFF;
        letter-spacing: 1px;
        float: left;
        line-height: 30px;
    }

    .item-value {
        color: #C4C4C4;
        float: left;
        line-height: 30px;
    }

    .item-value li {
        padding-right: 10px;
    }

    ul li {
        list-style: none;
        display: inline-block;
    }

    .copyright {
        margin-top: 15px;
        padding-top: 10px;
        border-top: 1px solid rgba(255, 255, 255, 0.2);
        font-size: 12px;
        text-align: center;
        color: #FFFFFF;
        letter-spacing: 0.86px;
        line-height: 27px;
    }

    .copyright img {
        position: relative;
        top: 5px;
        left: -8px;
    }

    .Qrcode {
        position: absolute;
        right: 80px;
        color: #C4C4C4;
        width: 70px;
        text-align: center;
    }
</style>